export interface FeatureFlags {
  id?: string | FeatureNames;
  enabled: boolean;
  features: Map<string, any>;
}

export enum FeatureNames {
  DAILY = 'daily',
}
